export default __webpack_public_path__ + "static/media/champion.017b7242.svg";